import { FC } from 'react'
import styled from 'styled-components'

interface IFResetButtonProps {
  onClick?: () => void
  className?: string
}

const ResetButton: FC<IFResetButtonProps> = ({ onClick, className }) => {
  const handleReset = () => {
    onClick && onClick()
  }

  return (
    <StyledButton type="button" onClick={handleReset} className={className}>
      <img src="/static/images/activity/reset.svg" />
      <span className="reset-label">초기화</span>
    </StyledButton>
  )
}

export default ResetButton

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.color.text_1};
  font-size: 12px;
  font-weight: 700;
  opacity: 1;
  border: none;
  background-color: transparent;
  transition: all 0.1s ease-in-out;

  :hover {
    cursor: pointer;
    opacity: 0.9;
  }

  .reset-label {
    margin-left: 4px;
  }
`
